module.exports = __webpack_public_path__ + "img/veracode.2f3956fc.png";